import Cookies from 'js-cookie'
import GlobalVars from "../config/globalVar";

export function setcookieFunc(accessToken, refreshToken, userDet) {
    accessToken &&
        Cookies.set(GlobalVars.TOKEN_KEY, accessToken);
    refreshToken &&
        Cookies.set(GlobalVars.REFRESH_KEY, refreshToken);
    //  Cookies.set('userInfo', JSON.stringify(userDet))
}

export function setanycookie(key, val){
    Cookies.set(key, JSON.stringify(val));
}

export function logoutFunc(setIsLoggedIn){
    setIsLoggedIn(false);
    Cookies.remove(GlobalVars.TOKEN_KEY);
    Cookies.remove(GlobalVars.REFRESH_KEY);
    Cookies.remove("userInfo");
    localStorage.clear()
}

export function getcookieFunc(){
    let cookieData = Cookies.get();
    // let accessToken = Cookies.get(GlobalVars.TOKEN_KEY);
    // let refreshToken = Cookies.get(GlobalVars.REFRESH_KEY);
    // let userDet = Cookies.get("userDetail");
    return {cookieData};
}